import {
  formatMoney
} from "../utils/offer.utils";

const OfferSummary = ({
  subtotal = 0,
  discountAmount = 0,
  taxAmount = 0,
  totalAmount = 0,
  currency = "INR"
}) => {
  return (
    <div className="offer-summary">
      <div className="offer-summary__row">
        <span>Subtotal</span>

        <strong>
          {formatMoney(
            subtotal,
            currency
          )}
        </strong>
      </div>

      <div className="offer-summary__row">
        <span>Discount</span>

        <strong className="offer-summary__discount">
          -{" "}
          {formatMoney(
            discountAmount,
            currency
          )}
        </strong>
      </div>

      <div className="offer-summary__row">
        <span>Tax</span>

        <strong>
          {formatMoney(
            taxAmount,
            currency
          )}
        </strong>
      </div>

      <div className="offer-summary__divider" />

      <div className="offer-summary__row offer-summary__total">
        <span>Total</span>

        <strong>
          {formatMoney(
            totalAmount,
            currency
          )}
        </strong>
      </div>
    </div>
  );
};

export default OfferSummary;